/*@flow*/
export const value2Option = (
  v: any,
  options: $Shape<{ value: any, label: string }>[]
): void | $Shape<{label: string, value: any, ...}> => options.find(({ value }) => value === v);

export const dropdownStyles = {
  input: (base: Object): any => ({ ...base, border: 'none' }),
  menu: (base: Object): any => ({ ...base, maxWidth: 400 }),
  control: (base: Object): any => ({
    ...base,
    border: 'none',
    borderBottom: 'solid 1px #ccc',
    borderRadius: 0,
    maxWidth: 400,
    boxShadow: 'none',
  }),
};
